import React from "react";
import { Award, CheckCircle2, TrendingUp } from "lucide-react";

const lbl = { fontSize: 10, letterSpacing: "0.16em", textTransform: "uppercase", color: "#737373" };
const V = { better: ["mejora real", "#4ade80"], worse: ["por debajo del inicio", "#a3a3a3"], within_error: ["dentro del margen de error", "#a3a3a3"], unqualified: ["sin cambio mínimo definido", "#737373"] };
const sign = (n) => (n > 0 ? `+${n}` : `${n}`);

const Stat = ({ l, v, sub, testid }) => (
  <div style={{ minWidth: 120 }} data-testid={testid}><div style={lbl}>{l}</div><div style={{ fontSize: 24, fontWeight: 800 }}>{v}</div>{sub && <div style={{ fontSize: 11, color: "#a3a3a3" }}>{sub}</div>}</div>
);

const Evolution = ({ items }) => (
  <div style={{ marginTop: 14 }} data-testid="mot-evolution">
    <div style={lbl}>Desde tu primera medición</div>
    {items.map((e) => (
      <div key={e.test} style={{ fontSize: 13, padding: "4px 0", borderTop: "1px solid rgba(255,255,255,0.05)" }}>
        <b>{e.test}</b>: {e.first} → {e.current} {e.unit || ""} ({sign(e.diff)}{e.pct !== undefined ? ` · ${sign(e.pct)} %` : ""}, {e.measurements} mediciones) · <span style={{ color: V[e.verdict][1] }}>{V[e.verdict][0]}</span>
      </div>
    ))}
  </div>
);

export const MotivationCard = ({ m, admin }) => {
  if (!m) return null;
  const done = m.milestones.filter((x) => x.achieved);
  const next = m.milestones.find((x) => !x.achieved && x.key.startsWith("streak")) || m.milestones.find((x) => !x.achieved);
  return (
    <div className="qv-card-app" style={{ padding: 18, marginBottom: 14 }} data-testid="motivation-card">
      <div style={{ fontSize: 14, color: m.headline.tone === "positive" ? "#4ade80" : "#d4d4d4", display: "flex", gap: 8, alignItems: "flex-start" }} data-testid="mot-headline">
        <TrendingUp size={16} style={{ flexShrink: 0, marginTop: 2 }} />{admin ? m.headline.admin_text : m.headline.text}
      </div>
      {(admin ? m.headline.admin_effort : m.effort) && <div style={{ fontSize: 13, color: "#a3a3a3", marginTop: 6, display: "flex", gap: 8 }} data-testid="mot-effort"><CheckCircle2 size={15} style={{ flexShrink: 0 }} />{admin ? m.headline.admin_effort : m.effort}</div>}
      <div style={{ display: "flex", gap: 22, flexWrap: "wrap", marginTop: 14 }}>
        <Stat l="Evaluaciones al día" v={m.completion.pct === null ? "—" : `${m.completion.pct} %`} sub={`${m.completion.up_to_date} de ${m.completion.active} activas`} testid="mot-pct" />
        <Stat l="Realizadas" v={m.total_completed} sub="validadas por el entrenador" testid="mot-total" />
        <Stat l="Racha en plazo" v={m.streak} sub={`mejor racha: ${m.best_streak}`} testid="mot-streak" />
      </div>
      {m.completion.pct !== null && <div style={{ height: 4, background: "#1f1f1f", marginTop: 12 }}><div style={{ width: `${m.completion.pct}%`, height: 4, background: "#E11D2E", transition: "width 0.6s ease" }} /></div>}
      <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginTop: 12 }} data-testid="mot-milestones">
        {done.map((x) => <span key={x.key} style={{ fontSize: 11, border: "1px solid #4ade8055", color: "#4ade80", padding: "3px 8px", display: "inline-flex", gap: 4, alignItems: "center" }} data-testid={`mot-ms-${x.key}`}><Award size={11} />{x.label}</span>)}
        {next && <span style={{ fontSize: 11, border: "1px dashed #444", color: "#737373", padding: "3px 8px" }} data-testid="mot-next">Siguiente hito: {next.label}</span>}
      </div>
      {m.improvements.length > 1 && <div style={{ fontSize: 12, color: "#a3a3a3", marginTop: 10 }} data-testid="mot-improvements">Mejoras verificadas: {m.improvements.map((i) => i.test).join(" · ")}</div>}
      {m.evolution.length > 0 && <Evolution items={m.evolution} />}
      {m.history.length > 0 && (
        <details style={{ marginTop: 12 }} data-testid="mot-history">
          <summary style={{ fontSize: 12, color: "#a3a3a3", cursor: "pointer" }}>Historial de evaluaciones realizadas ({m.total_completed})</summary>
          {m.history.map((h, i) => <div key={i} style={{ fontSize: 12, padding: "3px 0" }}>{h.date} · {h.test} · {h.value !== null && h.value !== undefined ? `${h.value} ${h.unit || ""}` : h.qualitative || "—"}</div>)}
        </details>
      )}
    </div>
  );
};
